
<p>
  <up-combo-field
    [ngClass]="fullWidth ? 'full-width' : 'half-width'"
    [errorState]="dropdownState"
    [fieldLabel]="labelName"
    [fieldMessage]="message"
    [items]="complexData"
    [template]="customTemplate"
    [filterKey]="filterKey"
    [formatInput]="formatForInput"
    [selectedItem]="selectedItem"       
    (selectedItemChanged)="onAppointmentTypeSelect($event)"
  >
    <input type="text"
           class="dropdown-field-width"
           [formControl]="dropdownForm"
           (blur)="onBlur()" />
  </up-combo-field>
</p>
